import { render, staticRenderFns } from "./ChatClosed.vue?vue&type=template&id=116f6462&scoped=true"
import script from "./ChatClosed.vue?vue&type=script&lang=js"
export * from "./ChatClosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f6462",
  null
  
)

export default component.exports